import * as jQuery from 'jquery';
import * as _ from 'underscore';

import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { COLORS, EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { ProductLiftChartComponent } from '../product-lift-chart/product-lift-chart.component';

@Component({
	selector: 'app-lift-card-v3',
	styleUrls: ['./lift-card-v3.component.css'],
	templateUrl: './lift-card-v3.component.html'
})
export class LiftCardV3Component extends ProductLiftChartComponent implements OnInit, WidgetCore, OnDestroy {
	@Input() sectiontitle: string;
	@Input() sectionclass: string;
	@Input() key: string;
	@Input() datatableconfig;
	@Input() colorsConfig: string;
	@Input() timeserieskey: string;
	@Input() barchartconfiguration: string;

	public devicedatatableconfig: string;
	public barChartDataConfiguration;

	@ViewChild('chartcontainer', { read: ElementRef }) chartContainer: ElementRef;
	public svgWidth;
	public svgHeight;
	public navigateSlideSubscription;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
		this.navigateSlideSubscription = EmitterService.get(EVENT_EMITTERS.NAVIGATE_TO_SLIDE).subscribe((response: any) => {
			if (response.widget.toLowerCase() === 'lift') {
				this.reload();
			}
		});
		EmitterService.get(EVENT_EMITTERS.SET_ACTIVE_STATE_TO_CURRENT_SLIDE).subscribe((response: any) => {
			if (response.widget.toLowerCase() === 'lift') {
				this.reload();
			}
		});
	}

	ngOnInit(): void {
		this.barChartDataConfiguration = JSON.parse(decodeURI(this.barchartconfiguration));
		this.devicedatatableconfig = JSON.parse(decodeURI(this.datatableconfig));
		this.colorsconfig = JSON.parse(decodeURI(this.colorsconfig));
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.requestData();
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
		if (this.navigateSlideSubscription) {
			this.navigateSlideSubscription.unsubscribe();
		}
	}

	reload(): void {
		this.svgWidth = jQuery(this.chartContainer.nativeElement).width() - 20;
		if (this.barChartDataConfiguration.svgHeight) {
			this.svgHeight = jQuery(this.chartContainer.nativeElement).height() - 100;
		}
	}

	processResponseData(): void {
		this.campaignsList = this.campaignsList.map((campaignItem, index) => {
			const campaign = {
				average_baseline:
					UtilityService.isUndefinedOrNull(Number(campaignItem.average_baseline)) ||
					Number(campaignItem.average_baseline) === 0
						? '<0.01'
						: campaignItem.average_baseline,
				average_exposed_rate:
					UtilityService.isUndefinedOrNull(Number(campaignItem.average_conversion_rate)) ||
					Number(campaignItem.average_conversion_rate) === 0
						? '<0.01'
						: campaignItem.average_conversion_rate,
				average_lift: campaignItem.average_lift.replace(/,/g, ''),
				graphData: [],
				id: campaignItem.campaign_id,
				legendLayout: {},
				name: campaignItem.campaign_name,
				subtitle: {},
				title: {},
				xAxis: {}
			};
			const baseline_data = [];
			const exposed_rate = [];
			const lift_data = [];
			const xAxisObj: any = {};
			const categories = [];
			campaignItem.data.forEach((dataObj) => {
				baseline_data.push(!Number(dataObj.average_baseline) ? 0 : Number(dataObj.average_baseline));
				exposed_rate.push({ y: Number(dataObj.average_conversion_rate), lift: this.buildLiftDataObject(dataObj) });
				lift_data.push(this.buildLiftDataObject(dataObj));
				categories.push(dataObj.impression_date);
			});
			xAxisObj.labels = { rotation: 0, style: { fontSize: '14px' } };
			xAxisObj.categories = categories;
			campaign.xAxis = xAxisObj;
			campaign.graphData = [
				{
					color: this.getColorFromColorConfig(0, 1),
					data: exposed_rate,
					fillColor: this.getColorFromColorConfig(0),
					name: 'Exposed Rate',
					type: 'column'
				},
				{
					color: this.getColorFromColorConfig(1, 1),
					data: baseline_data,
					fillColor: this.getColorFromColorConfig(1),
					name: 'Baseline Rate',
					type: 'column'
				}
			];
			return campaign;
		});
		if (!_.isEmpty(this.barChartDataConfiguration)) {
			this.configGraphOptions();
		}
	}

	public configGraphOptions(): void {
		this.campaignsList.forEach((campaign, index) => {
			campaign.legendLayout = {
				enabled: true
			};
			campaign.title = {
				align: 'left',
				style: {
					backgroundColor: this.barChartDataConfiguration.title.backgroundColor,
					color: this.colorUtilityService.getHEXByColorType(this.colorPalette, COLORS.SECONDARY, 1),
					fontFamily: 'Open Sans',
					fontSize: this.barChartDataConfiguration.title.fontSize,
					height: this.barChartDataConfiguration.title.height,
					left: 0,
					position: 'absolute',
					top: 0,
					width: this.barChartDataConfiguration.title.width,
					wordBreak: 'break-word'
				},
				text: `<b>${Number(campaign.average_lift) > 99 ? '>99' : Number(campaign.average_lift)}X Lift</b>`,
				useHTML: true,
				verticalAlign: this.barChartDataConfiguration.title.verticalAlign,
				y: this.barChartDataConfiguration.title.y
			};
			campaign.subtitle = {
				align: 'left',
				style: {
					backgroundColor: this.barChartDataConfiguration.subtitle.backgroundColor,
					color: this.colorUtilityService.getHEXByColorType(this.colorPalette, COLORS.SECONDARY, 1),
					fontFamily: 'Open Sans',
					fontSize: this.barChartDataConfiguration.subtitle.fontSize,
					'padding-top': '7px',
					whiteSpace: 'normal',
					width: this.barChartDataConfiguration.title.width,
					wordBreak: 'break-word'
				},
				text: `People who saw your digital ads were <b>${
					Number(campaign.average_lift) > 99 ? '>99' : Number(campaign.average_lift)
				} times more likely to visit your website</b> than the unexposed audience.`,
				useHTML: true,
				verticalAlign: this.barChartDataConfiguration.subtitle.verticalAlign,
				y: this.barChartDataConfiguration.subtitle.y
			};
		});
	}

	onResize(event: any): void {
		this.reload();
	}
	updateGraph(name: any): void {
		const filobj = _.filter(this.campaignsList, (el) => {
			return el.name === name;
		});
		this.campaignCarouselItem = filobj[0];
	}
}
